import { useParams } from "next/navigation";
import type { ParamsOf } from ".next/types/routes";


function useActiveConversationId(): number | undefined {
  const { id } = useParams<ParamsOf<"/[workspace]/conversation/[id]">>();
  const parsedId = id ? parseInt(id, 10) : undefined;
  return parsedId && !isNaN(parsedId) ? parsedId : undefined;
}

export { useActiveConversationId };
